import React, { useContext } from "react";
import logo from "../../assets/logo.png";
import style from "./Chatnav.module.css";
import { Authcontext } from "../context/Authcontext";
const Chatnav=()=>{
    const {currentuser}=useContext(Authcontext)
    return(
        <div className={style.nav}>
            <a  href="https://archminaashraf.com/">
                <img src={logo}/>
            </a>
            <div className={style.leftcontent}>
                <div className={style.admininfo}>
                    <img src={currentuser?.photoURL}/>
                    <p>{currentuser?.displayname}</p>
                </div>
                <svg onClick={()=>window.history.back()} style={{cursor:"pointer"}} xmlns="http://www.w3.org/2000/svg" width="40" height="41" viewBox="0 0 40 41" fill="none">
                    <path d="M8.3335 20.5L31.6668 20.5M8.3335 20.5L18.3335 10.5M8.3335 20.5L18.3335 30.5" stroke="#999999" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
        </div>
    )
}
export default Chatnav;